/**
 * Проверка домена для формы AdTag.
 *
 * U-label (кириллица) принимается: `new URL()` приводит его к A-label так же,
 * как браузер. Сервер — источник истины; здесь только отсекаем очевидный мусор.
 */
export function isValidAdTagDomain(raw: string): boolean {
    const value = raw.trim();

    if (value === '') {
        return false;
    }

    let asciiHost: string;
    try {
        const candidate = /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `http://${value}`;
        asciiHost = new URL(candidate).hostname.toLowerCase();
    } catch {
        return false;
    }

    if (asciiHost === '' || asciiHost.length > 253 || !/^[a-z0-9.-]+$/.test(asciiHost)) {
        return false;
    }

    const labels = asciiHost.split('.');

    if (labels.length < 2 || asciiHost.includes('..')) {
        return false;
    }

    for (const label of labels) {
        if (label.length === 0 || label.length > 63 || !/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i.test(label)) {
            return false;
        }
    }

    return /^(?:[a-z]{2,}|xn--[a-z0-9-]+)$/i.test(labels[labels.length - 1]);
}
